


























import { Component, Vue } from "vue-property-decorator";

@Component
export default class Top extends Vue {
  get align() {
    return this.$vuetify.breakpoint.xsOnly ? "left" : "center";
  }
}
